<template>
  <div id="main">
		<section id="myCarousel" class="carousel slide pc-display" data-ride="carousel">
			<!-- 轮播（Carousel）指标 -->
			<!-- <ol class="carousel-indicators">
				<li data-target="#myCarousel" data-slide-to="0" class="active"></li>
				<li data-target="#myCarousel" data-slide-to="1"></li>
				<li data-target="#myCarousel" data-slide-to="2"></li>
			</ol>    -->
			<!-- 轮播（Carousel）项目 -->
			<div class="carousel-inner">
				<div class="item active">
					<img src="../assets/img/index/banner1.jpg" width="100%" alt="First slide">
					<div class="carousel-caption carousel-bottom">
					</div>
				</div>
				<!-- <div class="item">
					<img src="../assets/img/index/banner2.jpg" width="100%" alt="Second slide">
					<div class="carousel-caption carousel-bottom">
					</div>
				</div>
				<div class="item">
					<img src="../assets/img/index/banner3.jpg" width="100%" alt="Third slide">
					<div class="carousel-caption carousel-bottom">
					</div>
				</div> -->
			</div>
		</section>
		<section id="yd-myCarousel" class="carousel slide yidong-display" data-ride="carousel">
			<!-- 轮播（Carousel）指标 -->
			<!-- <ol class="carousel-indicators">
				<li data-target="#yd-myCarousel" data-slide-to="0" class="active"></li>
				<li data-target="#yd-myCarousel" data-slide-to="1"></li>
				<li data-target="#yd-myCarousel" data-slide-to="2"></li>
			</ol>    -->
			<!-- 轮播（Carousel）项目 -->
			<div class="carousel-inner">
				<div class="item active">
					<img src="../assets/img/index/yd-banner1.jpg" width="100%" alt="First slide">
					<div class="carousel-caption carousel-bottom">
					</div>
				</div>
				<!-- <div class="item">
					<img src="../assets/img/index/banner2.jpg" alt="First slide">
					<div class="carousel-caption carousel-bottom">
					</div>
				</div>
				<div class="item">
					<img src="../assets/img/index/banner3.jpg" alt="First slide">
					<div class="carousel-caption carousel-bottom">
					</div>
				</div> -->
			</div>
		</section>
		<!-- 简介 -->
		<section class="introduction-bgi" id="introduction">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 section-title text-align-center" style="color: #A9713B;">
						<div class="wow bounceInUp">高思律师事务所·简介</div>
						<hr class="hr-size" id="about-hr"/>
					</div>
					<div class="col-xs-12 col-sm-7 col-md-7 index-p-detail">
						<p>北京高思律师事务所成立于2010年8月，致力于提供专业、优质、高效的法律服务。北京高思律师事务所的律师具有法学博士、硕士、学士学位，能够相互支持与配合，通过团队合作满足客户的法律需求。</p>
						<p>我们坚持以客户利益为中心，通过提高律师专业水平、流程设置、团队合作、邀请专业顾问等方式，为客户提供优质、务实、全面的法律服务。同时，我们还通过提升计算机管理、通讯设施水平，保证随时随地为客户提供即时所需的法律服务。</p>
						<p>我们具有为各型企业提供法律服务的经历，有专业可靠的团队及丰富的实践经验，可为公司制定详细的法律工作方案，为公司的日常经营管理提供全方位嵌入式的法律顾问服务。针对集团型公司，我们深知集团客户的核心利益所在，以及总部与分支机构在法律风险防范、内部管理上的问题所在，能够为集团客户提供符合需求的法律服务。</p>
						<p>我们的业务领域涉及公司事务、互联网科技服务、矿业能源、知识产权、投融资、合同、争议解决等方面，我们的律师在这些领域具有丰富的专业经验，相信能够达到客户要求。</p>
					</div>
					<div class="col-xs-12 col-sm-5 col-md-5">
						<img src="../assets/img/index/introduction.png" class="img-responsive" alt="公司简介图"/>
					</div>
				</div>
			</div>
		</section>
		<!-- 资讯 -->
		<section class="information-bgi" id="article" v-if="articleData.length">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 section-title text-align-center" style="color: #A9713B;">
						<div class="wow bounceInUp">高思律师事务所·资讯</div>
						<hr class="hr-size" id="about-hr"/>
					</div>
					<div class="col-xs-12 col-sm-4 col-md-4" v-for="(item, index) of articleData" :key="index" @click="handleToContentDetail(item.id)">
						<div class="information-item">
							<!-- <div v-if="item.image" class="article-img" :style="'background-image: url('+item.image+');'"></div> -->
							<div class="information-content">
								<p class="ic-title">{{item.title}}</p>
								<p class="ic-author">{{item.author}}</p>
								<p class="ic-detail">{{item.content}}</p>
								<!-- :class="item.image?'':'ic-detail-row'" -->
								<p class="ic-read">
									<span>READ</span>
									<span class="iconfont">&#xe610;</span>
								</p>
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 text-align-center">
						<div class="find-more-btn" @click="handleToPage('/article', 2)">
							<span>查看更多</span>
							<span class="iconfont">&#xe610;</span>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 业务 -->
		<section id="matter" class="information-bgi" style="background-color:#F3F3F5; position:relative;">
				<div class="section-title text-align-center" style="color: #A9713B;">
					<div class="wow bounceInUp">高思律师事务所·业务</div>
					<hr class="hr-size" id="about-hr"/>
				</div>
				<div class="row yidong-display" style="width:100%">
					<div class="col-xs-12 col-sm-12 col-md-12 x-gundong">
						<div class="law-box-item" :class="informationIndex==6?'law-box-item-active':''" @click="informationFuc(6)">
							<p class="iconfont">&#xe629;</p>
							<p>公司事务</p>
							<p>Corporate Affairs</p>
						</div>
						<div v-for="(item, index) in matterArr" :key="index"  class="law-box-item" :class="informationIndex==index?'law-box-item-active':''" @click="informationFuc(index)" v-if="item.name!='公司事务'">
							<p class="iconfont">{{item.icon}}</p>
							<p>{{item.name}}</p>
							<p>{{item.ename}}</p>
						</div>
					</div>
				</div>
				<div class="matter-list pc-display">
					<div class="matter-box-item" v-for="(item, index) in matterArr" :key="index" v-if="index<3">
						<p class="iconfont">{{item.icon}}</p>
						<p>{{item.name}}</p>
						<p>{{item.ename}}</p>
					</div>
					<div class="matter-item-change">
						<div class="lt" :class="matterIndex==1?'lt-color':'gt-color'"  @click="previousMatter">&lt;</div>
						<div class="change-index"><span>{{matterIndex}}</span>/{{matterArr.length}}</div>
						<div class="gt" :class="matterIndex==matterArr.length?'lt-color':'gt-color'" @click="nextMatter">&gt;</div>
					</div>
				</div>
				<div class="matter-item">
					<p class="matter-detail">高思律师事务所</p>
					<p class="matter-title">{{matterArr[selectIndex].name}}</p>
					<p class="matter-detail">{{matterArr[selectIndex].content}}</p>
					<p class="matter-detail">我们在{{matterArr[selectIndex].name}}领域提供的法律服务有：</p>
					<ul class="case-ul-li">
						<li v-for="(item, index) in matterArr[selectIndex].liContent" :key="index">{{item}}</li>
					</ul>
				</div>
		</section>
		<!-- 案例 -->
		<section class="information-bgi" id="cases">
			<div class="container">
				<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 section-title text-align-center" style="color: #A9713B;">
							<div class="wow bounceInUp">高思律师事务所·案例</div>
							<hr class="hr-size" id="about-hr"/>
						</div>
				</div>
			</div>
			<div style="background-color:#ffffff;">
				<div class="container">
					<div class="row">
						<div class="col-xs-12 col-sm-3 col-md-4">
							<img src="../assets/img/index/anli1.png" class="img-responsive" alt="案例">
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">公司事务</p>
							<ul class="case-ul-li anli-border">
								<li>为中国某行业协会进行反倾销反垄断审查；</li>
								<li>为北京某集团公司在全国各地的投资项目全程提供法律服务，结合各地政策及法规，向公司提供法律意见，规避公司法律风险，保障公司安全运营；</li>
								<li>为某全球最大广告法国广告公司进行经营者集中申报。</li>
							</ul>
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">互联网科技法律事务</p>
							<ul class="case-ul-li">
								<li>为北京某高新技术公司从公司设立到成长全程提供法律服务，结合欧盟隐私法律及中国政策，为公司建立一整套完备的数据安全保护体系，保障公司合法合规；</li>
								<li>为中国第一家青少年体能及人工智能研究中心提供软件著作权、专利申请全程知识产权保护。</li>
							</ul>
						</div>
						<div class="col-xs-12 col-sm-4 col-md-4">
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">矿业·能源</p>
							<ul class="case-ul-li anli-border">
								<li>代理北京某公司在新疆和硕县设立探矿权；</li>
								<li>代为客户管理新疆、陕西矿权；</li>
								<li>代理客户收购新疆拜城县铌钽矿；</li>
								<li>负责北京某公司湖北省钾盐矿权项目的法律工作；</li>
								<li>代理北京某公司收购位于新疆、贵州、广西、吉林数十个探矿权；</li>
								<li>代理北京某公司谈判解决与新疆某公司八十六个探矿权转让纠纷。</li>
							</ul>
							<img src="../assets/img/index/anli2.png" class="img-responsive" alt="案例">
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">知识产权</p>
							<ul class="case-ul-li">
								<li>为北京某知名电子市场申请注册商标；</li>
								<li>为北京某培训机构申请注册商标；</li>
								<li>为北京某医疗设备公司计算机软件著作权确权、侵权纠纷提供诉讼代理服务；</li>
								<li>为全国某知名中药生产企业技术秘密转让合同提供法律服务；</li>
								<li>为刘某与北京某出版社著作权侵权纠纷提供诉讼代理服务；</li>
								<li>为北京某公司诉某营业部不正当竞争提供诉讼代理服务；</li>
								<li>为某国际知名连锁餐饮企业商标使用权提供法律服务。</li>
							</ul>
						</div>	
						<div class="col-xs-12 col-sm-5 col-md-4">
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">投/融资</p>
							<ul class="case-ul-li anli-border">
								<li>为北京某公司投资武汉经营性公墓提供法律服务；</li>
								<li>为北京某公司投资蓄电池生产项目提供法律服务；</li>
								<li>为北京某公司收购北京某学校提供法律服务；</li>
								<li>为北京某公司陕西矿权项目合作开发融资项目提供法律服务；</li>
								<li>为北京某公司新疆矿权合作项目提供法律服务。</li>
							</ul>
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">合同</p>
							<ul class="case-ul-li anli-border">
								<li>为某集团公司矿权收购提供合同专项法律服务；</li>
								<li>为某日资化工企业股权转让提供合同专项法律服务；</li>
								<li>为某集团公司项目建设工程提供合同专项法律服务；</li>
								<li>为某电池生产企业产品全国营销提供合同专项法律服务； </li>
								<li>为某公司电影制作项目提供合同专项法律服务。</li>
							</ul>
							<p class="anli-point">高思律师事务所·案例</p>
							<p class="anli-title">争议解决</p>
							<ul class="case-ul-li">
								<li>代理黑龙江某乳品企业诉某丹麦企业、某澳大利亚企业合同纠纷仲裁案；</li>
								<li>代理北京某集团公司诉某拍卖公司拍卖合同纠纷诉讼案；</li>
								<li>代理法国某石油公司应诉产品质量纠纷案；</li>
								<li>代理新疆某公司诉其高级管理人员损害股东利益责任纠纷案;</li>
								<li>代理北京某研究所诉某集团公司兼并纠纷案;</li>
								<li>为黑龙江某薯业公司的境内外谈判、仲裁和诉讼提供法律服务，所代理案件均取得胜诉，并执行回款。</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 公司团队 -->
		<section class="information-bgi team-bgi" id="team">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-5 col-md-5 index-p-detail">
						<div class="about-title" style="color:#ffffff;">高思律师事务所</div>
						<div class="section-title wow bounceInLeft" style="color: #A9713B;">团队</div>
							<p class="index-p-detail" style="color:#ffffff;">我们具有为各型企业提供法律服务的经历，有专业可靠的团队及丰富的实践经验，可为公司制定详细的法律工作方案，为公司的日常经营管理提供全方位嵌入式的法律顾问服务。针对集团型公司，我们深知集团客户的核心利益所在，以及总部与分支机构在法律风险防范、内部管理上的问题所在，能够为集团客户提供符合需求的法律服务。</p>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12">
						<div class="find-more-btn" @click="handleToPage('/team', 5)" style="color:#ffffff;background-color:#A9713B;">
							<span>查看成员</span>
							<span class="iconfont">&#xe610;</span>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 立即咨询 -->
		<section class="consult">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-4 col-md-4">
						<input class="form-control" type="text" v-model="userName" placeholder="您的姓名">
						<input class="form-control" type="text" v-model="mobile" placeholder="您的电话">
					</div>
					<div class="col-xs-12 col-sm-6 col-md-6 yd-zx-content">
						<textarea class="form-control" v-model="leaveMessage" cols="30" rows="10" placeholder="输入您想咨询的问题"></textarea>
					</div>
					<div class="col-xs-12 col-sm-2 col-md-2" @click="messageBoard">
						<p>立即咨询</p>
					</div>
				</div>
			</div>
			<div class="toast toast-succuss" v-if="toastText">{{toastText}}</div>
		</section>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
export default {
	data () {
		return {
			articleData: [],
			userName:'',
			mobile: '',
			leaveMessage: '',
			toastText: '',
			matterArr: [{icon: '\ue62f', name: '互联网科技法律事务', ename:'Internet technology legal affairs',
			content: '互联网科技法律事务是高思顺应现代科技发展，与时俱进发展的业务之一。高思的律师在互联网科技领域具有丰富的经验，公司客户为互联网行业的高新技术公司，为公司客户提供了切实可行的法律方案，有效解决科技公司在发展中面临的法律问题。我们致力于尽快解决公司客户面临的法律问题，为其提供全方位的法律服务和解决方案，避免其因寻求不同帮助而浪费资源。', 
			liContent:['互联网科技公司设立、并购、注销、破产；',
			'互联网科技公司的数据安全及隐私保护；',
			'互联网科技公司常年法律顾问；',
			'互联网科技公司运营合规审查； ',
			'互联网科技公司商标、软件著作权、专利、域名、商业秘密等知识产权保护；',
			'互联网科技公司争议解决。']},
			{icon: '\ue62c', name: '矿业·能源', ename:'Mining and energy',
			content: '矿业及能源是我们的核心业务之一。我们的律师熟悉中国政府在矿业方面的法律法规及政策，在矿业权的申请、转让、开采、评估、设立矿业公司等方面具有丰富经验，为上百个矿业权项目提供过咨询、前期调查、谈判、申请、转让等法律服务，并涉及矿业权的争议解决和刑事案件，矿产种类包括金、铜、煤、风能、稀土、钾盐等。', 
			liContent:['矿业权申请、变更、转让及相关政府备案、审批；',
			'矿业权转让前期调查，转让谈判，合同条款的设计、拟定、签订；',
			'矿业勘探、开发公司设立，勘查单位的选择与勘查合同的签署；',
			'矿业公司运营法律风险审查；',
			'争议解决。']},
			{icon: '\ue62e', name: '知识产权', ename:' intellectual property',
			content: '知识产权包括著作权、商标、专利、商业秘密、不正当竞争等多项法律业务。我们的律师不仅接受过优质的知识产权法学教育，还在著作权取得、商标申请、商业秘密保护、不正当竞争，以及知识产权诉讼等实务领域具有多年经验，可以为客户提供优质的法律服务。', 
			liContent:['商标申请及范围；',
			'知识产权保护方案；',
			'不正当竞争行为审查； ',
			'争议解决。']},
			{icon: '\ue62b', name: '投/融资', ename:'Investment/financing',
			content: '公司无论大小，均会具有投资意愿，亦会产生融资需求。我们在该领域具有丰富的经验，可以通过提供专业法律服务，保障客户投、融资需求的实现。', 
			liContent:['投资前期风险调查；',
			'投资谈判；',
			'投资合同起草、修改、签订；',
			'资产管理；',
			'投资情况跟踪；',
			'项目融资；',
			'争议解决。']},
			{icon: '\ue62a', name: '合同', ename:'contract',
			content: '合同是确定各主体之间权利义务关系的重要载体。无论公司、个人还是其他组织，在日常工作生活中均会涉及各类合同。合同是否合法、是否完备，直接决定了各主体之间法律关系及权利义务，直至最终结果。 我们的律师熟悉合同法律法规及相关政策、规章，在合同领域具有多年的实践经验，并通过不断学习提高处理各类合同的能力。我们可以为客户提供合同方面的专业法律服务，努力保护客户利益。', 
			liContent:['合同起草、审查、修订；',
			'签约前法律风险调查； ',
			'合同主体审查；',
			'履约情况跟踪； ',
			'争议解决。']},
			{icon: '\ue62d', name: '争议解决', ename:'Dispute resolution',
			content: '民事商活动中，发生争议并寻求解决是十分普遍但又非常重要的事务。我们认为并相信，只有具备较强综合业务能力的情况下，才能在争议发生时为客户提供优质法律服务。因此，争议解决是高思重要业务之一。在这方面，我们熟悉法律，谈判、庭审经验丰富，并具有处理复杂问题的专业能力。实际工作中，我们既有通过诉讼否决兼并，亦有通过仲裁为客户挽回巨额损失，更有通过谈判避免重大损失发生的案例。', 
			liContent:['争议解决方案评估及确定；',
			'诉讼；',
			'仲裁；',
			'谈判；',
			'争议解决。']},
			{icon: '\ue629', name: '公司事务', ename:'Corporate Affairs',
			content: '公司法律事务是高思的核心业务之一，高思的律师在公司事务领域具有多年法律服务经验，为公司客户提供了切实可行的法律方案，有效解决其法律争议。我们致力于尽快解决公司客户面临的法律问题，为其提供全方位的法律服务和解决方案，避免其因寻求不同帮助而浪费资源。',
			liContent:['公司设立、重组、注销；',
			'经营者集中，反倾销反垄断；',
			'常年法律顾问；',
			'商业方案法律审查；',
			'公司法律风险评估；',
			'劳动解决方案；',
			'劳动解决方案；',
			'破产；',
			'争议解决。']}],
			selectIndex: 0,
			matterIndex: 1,
			informationIndex:6
		}
	},
	watch: {
		'$route': 'routerChange'
	},
	mounted () {
		this.selectIndex = this.matterArr.length-1
		this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
    })
		
		if (this.$route.query.flag == 1) {
			document.getElementById('introduction').scrollIntoView()
			window.scrollTo(0,this.scollPostion().top-80)
		} else if (this.$route.query.flag == 2) {
			document.getElementById('article').scrollIntoView()
			window.scrollTo(0,this.scollPostion().top-80)
		} else if (this.$route.query.flag == 3) {
			document.getElementById('matter').scrollIntoView()
			window.scrollTo(0,this.scollPostion().top-80)
		} else if (this.$route.query.flag == 4) {
			document.getElementById('cases').scrollIntoView()
			window.scrollTo(0,this.scollPostion().top-80)
		}  else if (this.$route.query.flag == 5) {
			document.getElementById('team').scrollIntoView()
			window.scrollTo(0,this.scollPostion().top-80)
		}  else {
			window.scrollTo(0,0)
		}
		this.getArticleList()
	},
	methods: {
		previousMatter () {
			if (this.matterIndex == 1) {
				return
			}
			this.matterIndex--;
			for (var i = 0; i < this.matterArr.length - 1; i++) {
				var temp = this.matterArr[this.matterArr.length - 1 - i];
				this.matterArr[this.matterArr.length - 1 - i] = this.matterArr[this.matterArr.length - 2 - i];
				this.matterArr[this.matterArr.length - 2 - i] = temp;
			}
		},
		nextMatter () {
			if (this.matterIndex == 7) {
				return
			}
			this.matterIndex++;
			this.selectIndex = this.matterArr.length-parseInt(1)
			var temp = this.matterArr[0]
			for (let i in this.matterArr) {
				this.$set(this.matterArr, i, this.matterArr[parseInt(i)+parseInt(1)])
			}
			this.matterArr[this.selectIndex] = temp
		},
		scollPostion() {
				var t, l, w, h;
				if (document.documentElement && document.documentElement.scrollTop) {
						t = document.documentElement.scrollTop;
						l = document.documentElement.scrollLeft;
						w = document.documentElement.scrollWidth;
						h = document.documentElement.scrollHeight;
				} else if (document.body) {
						t = document.body.scrollTop;
						l = document.body.scrollLeft;
						w = document.body.scrollWidth;
						h = document.body.scrollHeight;
				}
				return {
						top: t,
						left: l,
						width: w,
						height: h
				};
		},
		handleToContentDetail (id) {
			this.searchListDisplay = false
			this.$router.push({ path: '/articleDetail', query: {id: id} })
		},
		getArticleList () {
			this.axios.get('https://sys.qilinsports.com/law/sysarticle/page',{
				params: {page: 1, limit: 3},
			}).then((res) => {
				if (res.data.code == 0) {
					this.articleData = res.data.data.list
				}
			}).catch(function(error){
				console.log(error)//错误处理 相当于error
			})
		},
		messageBoard () {
			var _this = this
			var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
			if (this.userName.replace(/\s/g,'') == '') {
				alert('姓名不能为空')
				return
			}
			if (!myreg.test(this.mobile)) {
				alert('请输入正确的手机号')
				return
			}
			if (this.leaveMessage.replace(/\s/g,'') == '') {
				alert('问题不能为空')
				return
			}
			this.axios.post('https://sys.qilinsports.com/law/sysleavewords',{ 
				name: this.userName, mobile: this.mobile, leaveMessage: this.leaveMessage
			}).then((res) => {
				if (res.data.code == 0) {
					this.toastText = '提交成功'
					this.userName = ''
					this.mobile = ''
					this.leaveMessage = ''
					setTimeout(()=>{
						_this.toastText = ''
					}, 2000)
				}
			}).catch(function(error){
				console.log(error)
			})
		},
		routerChange (to, form) {
			if (to.query.flag == 1) {
				document.getElementById('introduction').scrollIntoView()
				window.scrollTo(0,this.scollPostion().top-80)
			} else if (to.query.flag == 2) {
				document.getElementById('article').scrollIntoView()
				window.scrollTo(0,this.scollPostion().top-80)
			} else if (to.query.flag == 3) {
				document.getElementById('matter').scrollIntoView()
				window.scrollTo(0,this.scollPostion().top-80)
			} else if (to.query.flag == 4) {
				document.getElementById('cases').scrollIntoView()
				window.scrollTo(0,this.scollPostion().top-80)
			}  else if (to.query.flag == 5) {
				document.getElementById('team').scrollIntoView()
				window.scrollTo(0,this.scollPostion().top-80)
			}  else {
				window.scrollTo(0,0)
			}
		},
		handleToPage (url, index) {
			this.$emit('changeNavIndex', index)
			this.$router.push({ path: url, query: {flag: index} })
		},
		informationFuc (index) {
			this.informationIndex = index
			this.selectIndex = index
		},
	}
}
</script>

<style scoped>
@import url("../assets/css/index.css");
@import url("../assets/css/common.css");
</style>


// WEBPACK FOOTER //
// src/components/main.vue